// extracted by mini-css-extract-plugin
export default {"pdfContainer":"ObavijestDetail_pdfContainer__fqP4V","mobile__size":"ObavijestDetail_mobile__size__rx2Nh"};